export default "__VITE_ASSET__DEA2Cr$A__"